import React, { useState } from 'react';
import { Alert, Button, Input, Typography } from 'antd';
import { useMissingCatalogueRequest } from '../viewmodels/useMissingCatalogueRequest';
export function MissingVariantRequest({ makeId, familyId, queryPk }) {
  const [open, setOpen] = useState(false), [text, setText] = useState('');
  const vm = useMissingCatalogueRequest('vehicle_variant', { make_id: makeId, family_id: familyId, query_pk: queryPk });
  return <div>
    <Button type="link" size="small" onClick={() => setOpen(value => !value)}>Missing a variant? Request it</Button>
    {open && <><Input aria-label="Missing variant name" maxLength={150} value={text} onChange={event => setText(event.target.value)} />
      <Button disabled={!text.trim() || !!vm.row} loading={vm.busy} onClick={() => vm.start(text)}>Request variant</Button></>}
    {vm.row && <Typography.Text type="success">Requested — an admin will review it.</Typography.Text>}
    {vm.error && <Alert type="warning" message={vm.error} action={<Button onClick={vm.retry}>{vm.joinId ? 'Join request' : 'Retry request'}</Button>} />}
  </div>;
}
